import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './components/landing/landing.component';
import { LoginComponent } from './components/login/login.component';
import { PasswordForgottenComponent } from '@src/app/components/password-forgotten/password-forgotten.component';
import { UserListComponent } from '@src/app/components/user-list/user-list.component';
import { LoginGuardService } from '@src/app/services/login-guard/login-guard.service';
import { MfaAuthenticatedGuardService } from '@src/app/services/login-guard/mfa-authenticated-guard.service';
import { MfaComponent } from '@src/app/components/login/mfa/mfa.component';
import { LayoutComponent } from '@src/app/components/layout/layout.component';
import { ConfigurationComponent } from '@src/app/components/configurations/configuration.component';
import { RetailerListComponent } from '@src/app/components/retailers/retailer-list.component';
import { BlueprintListComponent } from '@src/app/components/blueprints/blueprint-list.component';
import { CatalogComponent } from '@src/app/components/catalog/catalog.component';
import { RuleTemplateListComponent } from '@src/app/components/rule-templates/rule-template-list.component';
import { RetailerSettingsComponent } from '@src/app/components/retailers/retailer-settings/retailer-settings.component';
import { AttributeListComponent } from '@src/app/components/attributes/attribute-list.component';
import { ModuleCategoriesComponent } from '@src/app/components/catalog/module-categories/module-categories.component';
import { TranslationsComponent } from '@src/app/components/translations/translations.component';
import { MaterialsComponent } from '@src/app/components/materials/materials.component';
import { TexturesComponent } from '@src/app/components/textures/textures.component';
import { RetailerDataComponent } from '@src/app/components/retailers/retailer-data/retailer-data.component';
import { AccessModulesGuardService } from '@src/app/services/login-guard/access-modules-guard.service';
import { AccessRetailersGuardService } from '@src/app/services/login-guard/access-retailers-guard.service';
import { AccessUsersGuardService } from '@src/app/services/login-guard/access-users-guard.service';
import { AccessConfigurationsGuardService } from '@src/app/services/login-guard/access-configurations-guard.service';
import { AccessMaterialsGuardService } from '@src/app/services/login-guard/access-materials-guard.service';
import { AccessCatalogsGuardService } from '@src/app/services/login-guard/access-catalogs-guard.service';
import { AccessRetailerDataGuardService } from '@src/app/services/login-guard/access-retailer-data-guard.service';
import { EanComponent } from '@src/app/components/ean/ean.component';
import { AccessEansGuardService } from '@src/app/services/login-guard/access-eans-guard.service';
import { PayloadComponent } from '@src/app/components/payload/payload.component';
import { AccessRetailerSettingsGuardService } from '@src/app/services/login-guard/access-retailer-settings-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full',
  },
  { path: 'landing', component: LandingComponent },
  { path: 'login', component: LoginComponent },
  { path: 'login/mfa', component: MfaComponent, canActivate: [LoginGuardService] },
  { path: 'passwordReset', component: PasswordForgottenComponent },
  { path: 'payload', component: PayloadComponent },
  {
    path: '', component: LayoutComponent, canActivate: [MfaAuthenticatedGuardService], children: [
      { path: 'users', component: UserListComponent, canActivate: [AccessUsersGuardService] },
      { path: 'retailers', component: RetailerListComponent, canActivate: [AccessRetailersGuardService] },
      { path: 'retailer-settings', component: RetailerSettingsComponent, canActivate: [AccessRetailerSettingsGuardService] },
      { path: 'ean', component: EanComponent, canActivate: [AccessEansGuardService] },
      { path: 'configuration', component: ConfigurationComponent, canActivate: [AccessConfigurationsGuardService] },
      { path: 'rule-templates', component: RuleTemplateListComponent, canActivate: [AccessModulesGuardService] },
      { path: 'blueprints', component: BlueprintListComponent, canActivate: [AccessModulesGuardService] },
      { path: 'module-categories', component: ModuleCategoriesComponent, canActivate: [AccessModulesGuardService] },
      { path: 'attributes', component: AttributeListComponent, canActivate: [AccessModulesGuardService] },
      { path: 'materials', component: MaterialsComponent, canActivate: [AccessMaterialsGuardService] },
      { path: 'textures', component: TexturesComponent, canActivate: [AccessMaterialsGuardService] },
      { path: 'catalog', component: CatalogComponent, canActivate: [AccessCatalogsGuardService] },
      { path: 'translations', component: TranslationsComponent, canActivate: [AccessRetailersGuardService] },
      { path: 'retailer-data', component: RetailerDataComponent, canActivate: [AccessRetailerDataGuardService] },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
  providers: [
    LoginGuardService,
    MfaAuthenticatedGuardService,
    AccessUsersGuardService,
    AccessRetailersGuardService,
    AccessConfigurationsGuardService,
    AccessModulesGuardService,
    AccessMaterialsGuardService,
    AccessCatalogsGuardService,
    AccessRetailerSettingsGuardService,
    AccessRetailerDataGuardService,
    AccessEansGuardService,
  ],
})
export class AppRoutingModule {
}
